import React, { useEffect, useState } from 'react';
import CustomModal from '../../components/modal';
import ImageGallery from '../../components/imageGallery';
import { getImagePaths, loadImages } from '../../utils/imageLoader';

//images
const Squishies = ({ theme }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [squishies, setSquishies] = useState([]);
    
    //For dynamic imports (better for code splitting)
    useEffect(() => {
        const loadCollectionImages = async () => {
        const images = await loadImages('squishies');
        setSquishies(images);
        };
        loadCollectionImages();
    }, []);
    
    return (
      <div className='squishyPage'>
        <h3>Squishies</h3>
        <p>I also have a small collection of squishy things I enjoy fidjet with.</p>
        <ImageGallery
            images={squishies}
            onImageClick={setSelectedImage}
        />
        <CustomModal
            isOpen={!!selectedImage}
            onRequestClose={() => setSelectedImage(null)}
            theme={theme}
        >
          {selectedImage && (
              <img 
              src={selectedImage} 
              style={{ maxWidth: '100%', maxHeight: '80vh' }} 
              alt="Enlarged squishies" 
              />
          )}
        </CustomModal>
      </div>
    );
  };
  
  export default Squishies;